export default {
    url: '/mission_attempts',
    template: require('./view.html'),
    data: {
        title: 'Mission Attempts',
        priority: 898,
    },
    reloadOnSearch: false,
};
